// This file was generated by https://github.com/redbubble/design/blob/master/scripts/generateIcons.js
import React from 'react';
import Icon from '../Icon';

const GridIcon = props => <Icon {...props} dangerouslySetIcon={'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M20 2H4a2 2 0 00-2 2v16a2 2 0 002 2h16a2 2 0 002-2V4a2 2 0 00-2-2zm0 2v7h-7V4zM4 4h7v7H4zm0 16v-7h7v7zm9 0v-7h7v7z"/></svg>'} />;

GridIcon.displayName = 'GridIcon';

export default GridIcon;
